import { authModuleIds } from 'root/src/client/web/auth/descriptions/modules/authModuleIds';
export const signInWithProviderModalModule = {
    [authModuleIds.SIGN_IN_WITH_PROVIDER_MODAL_MODULE]: {
        moduleType: 'modal',
    },
};
